export const IMG_LINKS = {
    CAMPAIGN_BANNER_URL: 'https://static.zupper.com.br/website-campaigns/home_mes_do_consumidor.webp',
    CAMPAIGN_BANNER_MOBILE_URL: 'https://static.zupper.com.br/website-campaigns/home_mobile_mes_do_consumidor.webp',
    CAMPAIGN_LOGO_URL: 'https://static.zupper.com.br/website-campaigns/logo_mes_do_consumidor.webp',
    DEFAULT_BANNER_URL: 'https://static.zupper.com.br/website-campaigns/ZUPPER-BANNER-F_BUSCADOR-CAMPANHA_KV-2024.webp',
    DEFAULT_LOGO_URL: 'https://static.zupper.com.br/website-campaigns/Selo_Zupper_Selo_Zupper-Slogan.webp',
    DEFAULT_BANNER_MOBILE_URL: 'https://static.zupper.com.br/website-campaigns/ZUPPER-BANNER-F_BUSCADOR-MOBILE-CAMPANHA_KV-2024.webp'
}